import React, { ReactElement } from "react";

export default function DiscountIcon({
    fill,
    classes,
}: {
    fill: string;
    classes: string;
}): ReactElement {
    return (
        <i className={classes}>
            <svg
                width="16"
                height="24"
                viewBox="0 0 16 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.1836 0.912207C10.1836 0.912207 9.35839 4.49712 11.4212 7.70121C13.4834 10.9053 20.5258 17.2189 10.5644 23.0878C10.5644 23.0878 12.674 20.0896 11.6113 18.0435C10.5485 15.9972 8.26471 14.4745 8.6449 11.2704C8.6449 11.2704 5.63166 12.5239 6.96374 18.2016C6.96374 18.2016 5.26669 17.5832 4.55234 15.9098C4.55234 15.9098 3.4975 19.193 5.43293 23.0322C5.43293 23.0322 -4.7975 18.1533 3.44993 8.67676C3.44993 8.67676 3.6242 11.7698 4.84596 12.6266C4.84596 12.6266 2.83133 4.25151 10.1834 0.912079L10.1836 0.912207Z"
                    fill={fill}
                />
            </svg>
        </i>
    );
}
